<template>
	<div class="tabs tabs-center">
		<div class="tab-btns">
			<router-link class="tab-btn" to="/character">Character</router-link>
			<router-link class="tab-btn" to="/weapons">Weapons</router-link>
			<!-- <router-link class="tab-btn" to="/weather">Weather</router-link> -->
			<router-link class="tab-btn" to="/output">Output</router-link>
			<!-- <router-link class="tab-btn" to="/settings">Settings</router-link> -->

			<router-link class="tab-btn" to="/settings">
				<img alt="Settings" class="tab-icon tab-inner-fade tab-icon-cog" src="@/assets/sprites/cog.png">
			</router-link>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Tabs',
	}
</script>

<style lang="scss">
	@import '../assets/scss/_variables.scss';

	.tabs-center {
		margin: 0 auto;
	}

	.tab-btns {
		display: flex;
		font-family: $font-serif;
		font-size: 1.4rem;
		justify-content: space-around;
		margin: 0 auto;
		max-width: 1000px;
		padding: 20px;
		user-select: none;
		width: 100%;
	}

	.tab-btn {
		border: 1px solid #444;
		cursor: pointer;
		margin-right: 15px;
		padding: 10px 20px;
		color: white;
		text-decoration: none;

		&:hover:not(.router-link-exact-active) {
			border-color: #aaa;
		}
	}

	// Letters (eg "?")

	.tab-btn-center {
		align-items: center;
		display: flex;
		height: 46px; //@TODO: Fix hardcoded dimensions
		justify-content: center;
		padding: 5px;
		width: 50px; //@TODO
	}

	.tab-btn-character {
		font-size: 2.3rem;
	}

	.tab-inner-fade {
		opacity: .6;
	}


	// Icons

	.tab-icon {
		height: 24px;
		width: 24px;
		margin: 0 auto;
		display: block;
	}

	.tab-icon-cog {
		opacity: .6;
	}

	.tab-icon-docs {
		height: 24px;
		opacity: .6;
		width: 19px;
	}

	.tab-icon-home {
		// height: 24px;
		opacity: .6;
		// width: 19px;
	}

	.router-link-exact-active {
		cursor: default;
		border-color: $color-b;
	}
</style>
